import { checkUserValid } from '../service/login'

export default async function cannotShare (to, from, next) {
  let query = to.query
  if (query.from === 'singlemessage') {
    next('/login')
    return
  }
  if (!await checkUserValid(query.verify)) {
    next('/login')
    return
  }
  next()
}
